//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {loadYmap} from "vue-yandex-maps";
import Stores from "./components/Stores.vue";


const settings = {
    apiKey: process.env.yandexMapApiKey,
    lang: "ru_RU",
    coordorder: "latlong",
    version: "2.1",
};

export default {
    name: "StoresHome",
    emits: ["setStore"],
    props: [
        "yandexMapCoords",
        "activeCity",
        "getStores",
        "activeShop",
        "setStore",
        "onChangeSearch",
        "searchStore",
    ],
    data() {
        return {
            isGalleryOpen: false,
            yandexMap: null,

            imagesList: [],
            index: null,
            mapInstance: null,
        };
    },

    components: {
        Stores,
    },
    watch: {
        async getStores() {
            await this.yandexMapDestroy();
            this.yandexMapSetMarkers();
        },
        async activeShop() {
            await this.yandexMapDestroy();
            this.yandexMapSetMarkers();
        },
    },

    async mounted() {
        await this.yandexMapInit();
    },

    methods: {
        test() {
            // console.log("fdsjf");
        },
        // Инициализация и удаление карты
        async yandexMapInit() {
            await loadYmap({...settings, debug: true});

            this.yandexMap = new ymaps.Map(
              "yandex-map",
              {
                  center: this.yandexMapCoords,
                  zoom: 12,
                  behaviors: ["drag", "dblClickZoom", "multiTouch"],
              },
              {
                  maxZoom: 17,
              }
            );

            this.yandexMapSetMarkers();
        },
        yandexMapSetMarkers() {
            if (!this.yandexMap) {
                return null;
            }

            const yandexMap = this.yandexMap;
            const self = this;

            this.getStores.map((store) => {
                // Разработка визуальной части маркера
                const contentLayout = ymaps.templateLayoutFactory.createClass(
                  `<div class="store-map-pointer ${
                    this.activeShop === store.id || this.getStores.length === 1
                      ? " store-map-pointer--active"
                      : ""
                  }"><span>${store.address}</span></div>`
                );

                // Настройка паркера
                const myPlacemarkWithContent = new ymaps.Placemark(
                  [store.lat, store.lon],
                  {},
                  {
                      iconLayout: "default#imageWithContent",
                      iconImageHref: "",
                      content: "",
                      contentLayout: "",
                      imageSize: [60, 60],
                      imageOffset: [-30, -30],
                      contentOffset: [30, 20],
                      iconContentLayout: contentLayout,
                  }
                );

                // Добавление событий маркера
                myPlacemarkWithContent.events.add("click", function () {
                    self.onTapMarker(store.id);
                });

                // Добавление маркера на карту
                yandexMap.geoObjects.add(myPlacemarkWithContent);
            });

            // Автоцентрирование карта с отступами
            yandexMap.setBounds(yandexMap.geoObjects.getBounds(), {
                checkZoomRange: true,
                zoomMargin: [160, 0],
            });
        },
        async yandexMapDestroy() {
            await this.yandexMap?.geoObjects?.removeAll();
        },

        // Клик по маркеру
        onTapMarker(id) {
            this.$emit("setStore", id);
            // const scrollTarget = document.getElementById(id);
            // const topOffset = document.querySelector('.target').offsetHeight;
            // const elementPosition = scrollTarget.getBoundingClientRect().top;
            // const offsetPosition = elementPosition - topOffset;
            // document.querySelector('.target').scrollBy({
            //   top: offsetPosition,
            //   behavior: 'smooth'
            // });
        },

        setImagesList(store) {
            this.imagesList = [];
            const img = [
                this.$img(store.image_id.toString(), {width: 1900, quality: 90}),
            ];
            store.images_ids.forEach((t) => {
                img.push(this.$img(t.toString(), {width: 1900, quality: 90}));
            });
            this.imagesList = img;
        },
    },
};
